import { Box, Skeleton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { memo } from "react";

import type { GenericStatCardProps } from "./GenericStatCard.types";
import * as styles from "./GenericStatCard.styles";

export type { GenericStatCardProps } from "./GenericStatCard.types";

export const GenericStatCard = memo(function GenericStatCard({
  value,
  label,
  icon,
  accentColor,
  valueColor,
  isLoading = false,
}: GenericStatCardProps) {
  const theme = useTheme();
  const resolvedAccent = accentColor ?? theme.palette.primary.main;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.iconWrap(resolvedAccent)} aria-hidden>
        {icon}
      </Box>
      <Box sx={styles.valueBlock}>
        {isLoading ? (
          <Skeleton variant="text" width="55%" height={36} />
        ) : (
          <Typography sx={styles.value(valueColor)}>{value}</Typography>
        )}
        <Typography sx={styles.label}>{label}</Typography>
      </Box>
    </Box>
  );
});
